import React from 'react';

import { Box, Divider, Group, Stack, Text, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import ReadonlyWorkoutNotesRTE from 'components/workout-program/ReadonlyWorkoutNotesRTE';

interface PreviousClassNotesProps {
  notes?: string | null;
}

// Read-only staff display of a class's legacy Programming notes (from `/programs`).
const PreviousClassNotes = ({ notes }: PreviousClassNotesProps): JSX.Element | null => {
  if (!notes?.trim()) return null;

  return (
    <Stack spacing='xs'>
      <Divider my='md' />
      <Group spacing={6} align='center'>
        <Text weight={600}>Legacy Programming</Text>
        <Tooltip
          label='Legacy programming. Assign a Workout to this class to replace it.'
          multiline
          width={240}
          withArrow
          position='top'
        >
          <Box
            component='span'
            sx={theme => ({ display: 'inline-flex', cursor: 'help', color: theme.colors.gray[5] })}
          >
            <IconInfoCircle size={16} />
          </Box>
        </Tooltip>
      </Group>
      <ReadonlyWorkoutNotesRTE workoutNotes={notes} />
    </Stack>
  );
};

export default PreviousClassNotes;
